import { createSlice } from '@reduxjs/toolkit';
import { PushTokensResponse, UserResponse } from 'src/types';
import { getToken, removeToken, saveToken } from 'src/utils/auth';
import { setHeaderAuth } from 'src/utils/api';

export interface AuthStateType {
  loading: boolean;
  loadingLogin: boolean;
  user: UserResponse | null;
  token: string | null;
}

const initialToken = getToken();

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loading: !!initialToken,
    loadingLogin: false,
    user: null,
    token: initialToken,
  } as AuthStateType,
  reducers: {
    login: (state, action) => {},
    loadUser: (
      state,
      action: { payload: { onLoaded?: () => void } | undefined; type: string }
    ) => {},
    changeCustomer: (state, action: { payload: string; type: string }) => {},
    logout: (state) => {
      removeToken();
      setHeaderAuth(null);

      return {
        loading: false,
        loadingLogin: false,
        user: null,
        token: null,
      };
    },
    setLoginLoading: (state, action) => {
      if (action.payload === state.loadingLogin) {
        return state;
      }

      return {
        ...state,
        loadingLogin: action.payload,
      };
    },
    setAuthLoading: (state, action) => {
      if (action.payload === state.loading) {
        return state;
      }

      return {
        ...state,
        loading: action.payload,
      };
    },
    setAuthData: (state, action) => {
      saveToken(action.payload.token);
      setHeaderAuth(action.payload.token);

      return {
        ...state,
        loading: false,
        user: action.payload.user,
        token: action.payload.token,
      };
    },
    updateAuthData: (state, action) => {
      return {
        ...state,
        loading: false,
        user:
          action.payload && state.user
            ? { ...state.user, ...action.payload }
            : action.payload,
      };
    },
    registerPushToken: (state, action: { payload: string; type: string }) => {},
    updatePushToken: (
      state,
      action: { payload: PushTokensResponse[]; type: string }
    ) => {
      if (!state.user) {
        return state;
      }

      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          push_tokens: action.payload,
        },
      };
    },
  },
});

export const {
  setAuthData,
  setAuthLoading,
  setLoginLoading,
  login,
  logout,
  loadUser,
  updateAuthData,
  registerPushToken,
  updatePushToken,
  changeCustomer,
} = authSlice.actions;

export default authSlice.reducer;
